import { useURLParameters } from 'hooks';
import { ShiftDistributionModalViewType } from 'pages/Settings/modals/ShiftDistributionRulesTieringModal/ShiftDistributionRulesTieringModal.constants';
import {
  ShiftDistributionComponentMap,
  tieringDetailsModalRoutingService,
} from 'pages/Settings/modals/ShiftDistributionRulesTieringModal/ShiftDistributionRulesTieringModalRouting.constants';
import { createContext, FC, useCallback, useContext, useEffect } from 'react';

export interface ITieringDetailslUI {
  isOpen: boolean;
  onClose: () => void;
  tieringDetailsActiveModalView: ShiftDistributionModalViewType;
}

export const TieringDetailsViewUIContext = createContext<ITieringDetailslUI>(
  {} as ITieringDetailslUI,
);

export const TieringDetailsViewUIProvider: FC = ({ children }) => {
  const [{ tieringDetailsActiveModalView }, { removeParam }] =
    useURLParameters<{ activeModalView: ShiftDistributionModalViewType }>();

  const handleClose = useCallback(() => {
    tieringDetailsModalRoutingService.close();
  }, []);

  useEffect(() => {
    if (!Object.keys(ShiftDistributionComponentMap).includes(tieringDetailsActiveModalView)) {
      removeParam(['tieringDetailsActiveModalView']);
    }
  }, [tieringDetailsActiveModalView, removeParam]);

  return (
    <TieringDetailsViewUIContext.Provider
      value={{
        isOpen: !!tieringDetailsActiveModalView,
        onClose: handleClose,
        tieringDetailsActiveModalView:
          tieringDetailsActiveModalView as ShiftDistributionModalViewType,
      }}
    >
      {children}
    </TieringDetailsViewUIContext.Provider>
  );
};

export const useTieringDetailsModalUIContext = () =>
  useContext<ITieringDetailslUI>(TieringDetailsViewUIContext);
